<form id="dynamicForm-form" class="dynamic-form" [formGroup]="form">
  <div id="dynamicForm-form-div" class="container-fluid">
    <div class="row" id="dynamicForm-form-div2">
      @for (field of fields; track field) {
        <ng-container id="dynamicForm-form-ngContain">
          @if (
            field.type !== 23 &&
            field.type !== 1 &&
            field.type !== 22 &&
            field.type !== 9 &&
            field.type !== 14 &&
            !field?.isHidden
          ) {
            <div [ngClass]="field.class ? field.class : 'col-md-4'" id="dynamicForm-form-div3">
              <ng-container id="dynamicForm-form-ngContain2" dynamicField [field]="field" [group]="form" />
              <span id="dynamicForm-form-span" class="space"></span>
            </div>
          }
          @if (field.type === 23 || field.type === 1 || field.type === 22 || field.type === 9 || field.type === 14) {
            <div id="dynamicForm-form-div4" class="col-12">
              <ng-container id="dynamicForm-form-ngContain3" dynamicField [field]="field" [group]="form" />
              <span id="dynamicForm-form-span2" class="space"></span>
            </div>
          }
        </ng-container>
      }
    </div>
  </div>
</form>
